// Quickbuy sizes: AJAX add to cart
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.pb-size-btn');
  if (!btn) return;

  e.preventDefault();

  const id = btn.getAttribute('data-variant-id');
  if (!id || btn.disabled) return;

  const prevText = btn.textContent;
  btn.disabled = true;
  btn.textContent = '...';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(id),
        quantity: 1
      })
    });

    if (!res.ok) throw new Error('add failed');
    await res.json();

    const openers = [
      '[data-cart-drawer-open]',
      '[data-cart-toggle]',
      'a[href="/cart"]',
      '.site-control__cart',
      '.header__cart'
    ];

    for (const sel of openers) {
      const el = document.querySelector(sel);
      if (el) {
        el.click();
        break;
      }
    }

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
  } catch (err) {
    window.location.href = '/cart';
  } finally {
    btn.disabled = false;
    btn.textContent = prevText;
  }
});
// Badge LIMITADO para productos TREINOXPOMS
function addTreinoLimitadoBadges() {
  const productLinks = document.querySelectorAll('.product-block a[href*="/products/"]');

  productLinks.forEach(function (link) {
    const href = (link.getAttribute('href') || '').toLowerCase();
    const text = (link.textContent || '').toLowerCase();

    const isTreinoPoms =
      href.includes('treinoxpoms') ||
      href.includes('treino-x-poms') ||
      text.includes('treinoxpoms') ||
      text.includes('treino x poms');

    if (!isTreinoPoms) return;

    const card = link.closest('.product-block');

    if (!card || card.querySelector('.treino-limitado-badge')) return;

    const imageArea =
      card.querySelector('.pb-media') ||
      card.querySelector('.image-inner') ||
      card.querySelector('img')?.parentElement ||
      card;

    imageArea.style.position = 'relative';

    const badge = document.createElement('div');
    badge.className = 'treino-limitado-badge';
    badge.textContent = 'LIMITADO*';

    imageArea.appendChild(badge);
  });
}

document.addEventListener('DOMContentLoaded', addTreinoLimitadoBadges);
window.addEventListener('load', addTreinoLimitadoBadges);

const treinoObserver = new MutationObserver(addTreinoLimitadoBadges);
treinoObserver.observe(document.body, {
  childList: true,
  subtree: true
});
// Badge RE-STOCK para Polerón Stone Estampado Blanco
function addStoneRestockBadge() {
  const productLinks = document.querySelectorAll('.product-block a[href*="/products/"]');

  productLinks.forEach(function (link) {
    const href = (link.getAttribute('href') || '').toLowerCase();

    if (!href.includes('/products/poleron-stone-estampado-blanco')) return;

    const card = link.closest('.product-block');

    if (!card || card.querySelector('.treino-restock-badge')) return;

    const imageArea =
      card.querySelector('.pb-media') ||
      card.querySelector('.image-inner') ||
      card.querySelector('img')?.parentElement ||
      card;

    imageArea.style.position = 'relative';

    const badge = document.createElement('div');
    badge.className = 'treino-restock-badge';
    badge.textContent = 'RE-STOCK';

    imageArea.appendChild(badge);
  });
}

document.addEventListener('DOMContentLoaded', addStoneRestockBadge);
window.addEventListener('load', addStoneRestockBadge);

const stoneRestockObserver = new MutationObserver(addStoneRestockBadge);
stoneRestockObserver.observe(document.body, {
  childList: true,
  subtree: true
});


/* ==========================================
   TREINO - MOBILE PRODUCT CARD GALLERY
   Swipe aislado del slider interno del theme
   ========================================== */

(function () {
  let activeGallery = null;
  let startX = 0;
  let startY = 0;
  let startScrollLeft = 0;
  let horizontalGesture = false;

  document.addEventListener(
    'touchstart',
    function (e) {
      if (window.innerWidth >= 768) return;

      const gallery = e.target.closest('[data-treino-mobile-gallery]');
      if (!gallery) return;

      const touch = e.touches[0];

      activeGallery = gallery;
      startX = touch.clientX;
      startY = touch.clientY;
      startScrollLeft = gallery.scrollLeft;
      horizontalGesture = false;

      delete gallery.dataset.justSwiped;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      if (!activeGallery) return;

      const touch = e.touches[0];
      const dx = Math.abs(touch.clientX - startX);
      const dy = Math.abs(touch.clientY - startY);

      if (dx > 8 && dx > dy) {
        horizontalGesture = true;
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function () {
      if (!activeGallery) return;

      const gallery = activeGallery;
      const actuallyMoved =
        Math.abs(gallery.scrollLeft - startScrollLeft) > 4;

      if (horizontalGesture || actuallyMoved) {
        gallery.dataset.justSwiped = 'true';

        setTimeout(function () {
          delete gallery.dataset.justSwiped;
        }, 450);
      }

      activeGallery = null;
      horizontalGesture = false;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchcancel',
    function () {
      activeGallery = null;
      horizontalGesture = false;
    },
    { passive: true }
  );

  /*
    La galería NO está dentro del <a>.
    Tap corto = abrir producto.
    Swipe = no navegar.
  */
  document.addEventListener(
    'click',
    function (e) {
      if (window.innerWidth >= 768) return;

      const gallery = e.target.closest('[data-treino-mobile-gallery]');
      if (!gallery) return;

      e.preventDefault();
      e.stopPropagation();

      if (gallery.dataset.justSwiped === 'true') {
        return;
      }

      const productUrl = gallery.dataset.productUrl;
      if (productUrl) {
        window.location.href = productUrl;
      }
    },
    true
  );
})();


/* ==========================================
   TREINO - REBIND TOOLBAR AFTER AJAX FILTER
   El theme reemplaza el toolbar y product-list
   ========================================== */

(function () {
  if (!window.jQuery) return;

  window.jQuery(document).on(
    'cc:component:load.treinoCollectionToolbar',
    function (event, component) {
      if (component !== 'product-block') return;

      if (typeof window.initCollectionToolbar === 'function') {
        window.initCollectionToolbar();
      }
    }
  );
})();